import logoImage from "../assets/images/logoblue.png";
import emailBg from "../assets/images/email_bg.png";

export const getNotifyAdminEmailTemplate = (userData, isOrgAdmin, orgName) => {
  return `
  <!DOCTYPE html>
  <html lang="en">
    <head>
      <meta charset="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>Admin Added Notification</title>
      <style>
        body {
          background-color: #00a7cd;
          background-image: url(${emailBg});
          background-size: cover;
          background-repeat: no-repeat;
          font-family: Arial, sans-serif;
        }
  
        .email-container {
          width: 100%;
          max-width: 600px;
          margin: 0 auto;
        }
  
        .header {
          text-align: center;
          margin-bottom: 20px;
        }
  
        .logo {
          width: 200px;
          height: auto;
        }
  
        .email-content {
          padding: 20px;
          background-color: #ffffff;
          border-radius: 10px;
        }
  
        h1 {
          color: #333;
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 20px;
          text-align: center;
        }
  
        p {
          color: #333;
          font-size: 14px;
          line-height: 1.5;
          margin-bottom: 15px;
        }
  
        .user-info {
          font-size: 14px;
          margin-bottom: 15px;
          color: #333;
        }
  
        .footer-container {
          text-align: center;
          margin-top: 30px;
        }
  
        .footer-container p {
          color: #ffffff;
          font-size: 12px;
          margin: 5px 0;
        }
      </style>
    </head>
    <body>
      <div class="email-container">
        <div class="email-content">
          <div class="header">
            <img src="${logoImage}" alt="Logo" class="logo" />
          </div>
          <h1>Congratulations, You're Now an Admin!</h1>
          <p>Hi ${userData.firstName + " " + userData.lastName},</p>
          ${
            isOrgAdmin
              ? `<p>We're pleased to inform you that you have been successfully added as an Administrator for ${orgName} on QuickTales.</p>`
              : `<p>We're pleased to inform you that you have been successfully added as an Administrator on QuickTales.</p>`
          }
          <p>As an Admin, you will now have access to additional features and controls to manage and oversee QuickTales activities${
            isOrgAdmin ? ` within ${orgName}` : ""
          }. If you have any questions about your new responsibilities, feel free to reach out to our support team${
    isOrgAdmin ? " or the organization's main point of contact" : ""
  }.</p>
          <p>Please keep this information secure, and if you believe this was done in error or if you need further assistance, don't hesitate to contact us at Support@QuickTales.com.</p>
          <p>Welcome aboard as an Admin!</p>
          <p>Kind regards,</p>
          <p>The QuickTales Team</p>
        </div>
      </div>
  
      <footer class="footer-container">
        <p>Support@QuickTales.com</p>
        <p>© 2024 QuickTales</p>
      </footer>
    </body>
  </html>
  `;
};

export default getNotifyAdminEmailTemplate;
